import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation, useNavigate } from 'react-router'
import { useBlockNavigation } from '../../../common/hooks/useBlockNavigation'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { COMPONENTS } from '../../../routers/constants'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { COMPANY_TYPES } from '../../../utils/common'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import Button from '../../common/preferenceSetting/detailTemplate/Button'
import InputSearchTemplate from '../../common/preferenceSetting/templates/InputSearchTemplate'
import { getDetailPanel, getKeyPanels, saveTemplate } from './helper'
import classes from './index.module.scss'
import {
  applySetting,
  keyLoading,
  selectIsFiinGateTemplate,
  selectIsNotHasChange,
  selectLoading,
  selectPanelById,
  selectPanelId,
  selectTemplateId,
  selectTemplateName,
  selectTemplateSearch,
  setIsNotHasChange,
} from './store/slice'
import { getTemplatesSearchThunk } from './store/thunk'

const PreferenceSettingHeader = ({ setIsShowPreferenceSetting }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const loadingSearch = useSelector(selectLoading(keyLoading.TEMPLATE_SEARCH))
  const templateSearch = useSelector(selectTemplateSearch)
  const companyType = useSelector(selectCompanyInfo).companyType
  const templateName = useSelector(selectTemplateName)
  const templateId = useSelector(selectTemplateId)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const userType = useSelector(selectUserType)
  const isNotHasChange = useSelector(selectIsNotHasChange)
  const isFiinGateTemplate = useSelector(selectIsFiinGateTemplate)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const [isShowPopupSuccess, setIsShowPopupSuccess] = useState(false)

  const { showPrompt, confirmNavigation, cancelNavigation } =
    useBlockNavigation({
      isBlock: !isNotHasChange,
      ignorePath:
        COMPONENTS.companyAnalysis.components.financial.components
          .financialAnalysis.route,
    })

  const callApiSearch = (value) => {
    dispatch(getTemplatesSearchThunk(value))
  }

  const openTemplate = (data) => {
    dispatch(setIsNotHasChange(true))

    const keysPanel = getKeyPanels(companyType)

    const panels = data.financialAnalysisTemplateData
      ? JSON.parse(data.financialAnalysisTemplateData)
      : keysPanel.map((panel) => getDetailPanel(panel))

    dispatch(
      applySetting({
        templateId: data.financialAnalysisTemplateId,
        templateName: data.financialAnalysisTemplateName,
        panels,
        isFiinGateTemplate: data.isFiinGateTemplate,
      }),
    )
  }

  const openMoreTemplate = () => {
    if (isDisable) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    } else {
      const params = `?organizationId=${organizationId}&preferenceSetting=true`
      navigate(
        COMPONENTS.companyAnalysis.components.financial.components
          .financialAnalysis.route + params,
      )
    }
  }

  const save = async (data) => {
    const result = await saveTemplate(
      {
        ...data,
        panels: panelId.map((id) => {
          const panel = panelById[id]

          return {
            ...panel,
            setting: panel.setting
              ? { ...panel.setting, year: null }
              : undefined,
          }
        }),
      },
      companyType,
    )
    if (result) {
      dispatch(setIsNotHasChange(true))
    }
    return result
  }

  const openSetting = () => {
    if (isDisable) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    } else {
      setIsShowPreferenceSetting(true)
    }
  }

  const isDisable =
    AUTHORIZATION_API.companyAnalysis.preferenceSettings[
      userType.userTypeId
    ] === AUTHORIZATION_TYPE.DISABLE

  return (
    <Element
      className={classes.preferenceSettingHeaderContainer}
      style={{ borderColor: '#D1D1D1' }}
    >
      <InputSearchTemplate
        callApiSearch={callApiSearch}
        loadingSearch={loadingSearch}
        dataTemplateSearch={[
          {
            templateType: COMPANY_TYPES.CORPORATE,
            title: 'preferenceSetting.CORPORATE',
            data: templateSearch[COMPANY_TYPES.CORPORATE],
          },
          {
            templateType: COMPANY_TYPES.BANK,
            title: 'preferenceSetting.BANK',
            data: templateSearch[COMPANY_TYPES.BANK],
          },
          {
            templateType: COMPANY_TYPES.NON_BANK,
            title: 'preferenceSetting.NON_BANK',
            data: templateSearch[COMPANY_TYPES.NON_BANK],
          },
          {
            templateType: COMPANY_TYPES.SECURITIES,
            title: 'preferenceSetting.SERCURITY',
            data: templateSearch[COMPANY_TYPES.SECURITIES],
          },
          {
            templateType: COMPANY_TYPES.LIFE_INSURANCE,
            title: 'preferenceSetting.LIFE_INSURANCE',
            data: templateSearch[COMPANY_TYPES.LIFE_INSURANCE],
          },
          {
            templateType: COMPANY_TYPES.NON_LIFE_INSURANCE,
            title: 'preferenceSetting.NON_LIFE_INSURANCE',
            data: templateSearch[COMPANY_TYPES.NON_LIFE_INSURANCE],
          },
        ]}
        nameKey="financialAnalysisTemplateName"
        style={{
          borderColor: 'transparent',
          borderStyle: 'none',
          borderWidth: 0,
          height: '24px',
          fontSize: 12,
        }}
        openMoreTemplate={openMoreTemplate}
        openTemplate={openTemplate}
        isNotHasPermission={isDisable}
        templateNameActive={templateName}
      />
      <Element
        style={{ borderLeft: '1px solid #9C9C9C' }}
        className={classes.right}
      >
        <Button
          saveTemplate={save}
          defaultTemplateProp={{ templateName, templateId }}
          action={() => setIsShowPopupSuccess(true)}
          isButtonSave
          isNotHasPermission={isDisable}
          isFiinGateTemplateProp={isFiinGateTemplate}
        >
          <Icon
            className={['icon-save', classes.firstRight].join(' ')}
            style={{ color: '#0553A5' }}
          />
        </Button>
        <Icon
          className={['icon-settings', classes.secondRight].join(' ')}
          style={{ color: '#9C9C9C' }}
          onClick={openSetting}
        />
      </Element>
      <PopupAction
        isShow={isShowPopupSuccess}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={() => setIsShowPopupSuccess(false)}
        btnCancel={{
          label: 'preferenceSetting.CLOSE',
          event: () => setIsShowPopupSuccess(false),
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.SAVE_SUCCESS" />
      </PopupAction>
      <Button
        saveTemplate={save}
        defaultTemplateProp={{ templateName, templateId }}
        action={confirmNavigation}
        isNotHasPermission={isDisable}
        isFiinGateTemplateProp={isFiinGateTemplate}
        isOpenConfirm={showPrompt}
        setIsOpenConfirm={cancelNavigation}
      />
    </Element>
  )
}

PreferenceSettingHeader.propTypes = {
  setIsShowPreferenceSetting: PropTypes.func.isRequired,
}

export default PreferenceSettingHeader
